<template>
    <div>
        <label class="btn btn-sm bg-primary ml-3 text-white custom-file-upload d-block bg-success d-flex align-items-center botonWidth">
            <input 	class="d-none" 
                    type="file" 
                    @input="readExcel"
                    ref="input-file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
            <img class="icon mr-1" src="@/assets/img-priv/excellogo.png" style="width:15px; height:20px;"/>           
            <div class="font-13 btntooltip ">
                <span class="d-none d-md-block">Cargar pedido con Excel</span>
                <span class="btntooltiptext"><router-link to="/clientes/ayuda/9">Ir al video tutorial</router-link></span>
            </div>
        </label>
        <b-modal id="modal-articulos-excel" size="xl" no-close-on-backdrop no-close-on-esc>
            <pm-tabla-carrito excel="true" 
                                :articulosExcel="listaArticulosExcelEnviar" 
                                :rutaCargado="ruta"
                                class="px-5"
                                @togleMenu=togleMenu>
            </pm-tabla-carrito>
        </b-modal>
        <b-modal id="modal-articulos-excel-incorrectos" size="xl" no-close-on-backdrop no-close-on-esc modal-dialog-scrollable>
            <div class="row mb-2 fuente-textos">                
                <!-- info para descargar tablas a excel -->
                <div class="col-3 vertical-align-center d-none d-lg-block">
                    <div class="col-12">
                        <div class="row vertical-align-center">
                            <div class="col-12 text-center">
                                <i class="fas fa-exclamation-triangle triangulo"></i>
                            </div>
                            <div class="offset-1 col-lg-10 offset-xl-2 col-xl-8 borde mt-2">
                                <span class="font-weight-bold">Opción 1:</span>
                                    Puede modificar el 
                                    código del producto
                                    dando clic en el botón
                                    "Editar"<i class="fas fa-pencil-alt color-azul"></i>
                                
                            </div>
                            <div class="offset-1 col-lg-10 offset-xl-2 col-xl-8 borde mt-2">
                                <span class="font-weight-bold">Opción 2:</span>
                                Puede descargar su tabla en un archivo de excel, 
                                y hacer las modificaciones 
                                directamente desde su dispositivo. 
                                Dando clic en el botón : 
                                <span class="font-weight-bold">"Descargar tablas"</span>
                            </div>
                        </div>
                        <div class="row mt-2">
                            <div class="col-12 text-center">
                                <button class="btn btn-sm bg-descarga borde" @click="onexport">Descargar tablas</button>
                            </div>
                        </div>
                    </div>                    
                </div>  
                
                <div class="col-12 text-center d-block d-lg-none mb-1">
                    <i class="fas fa-exclamation-triangle triangulo"></i>
                </div>
                
                <!--Tablas de códigos inexistentes y cantidad incorrecta-->
                <div class="col-12 col-lg-9 rows">
                    <div class="col-12 text-center" v-if="listaArticulosExcelNoEncontrados.length > 0">
                        <div class="text-center font-weight-bold">
                            <span class="text-danger">Los siguientes códigos no existen en el catálogo Difarmer:</span>
                        </div>
                        <table  class="table table-sm table-bordered">
                            <thead class="text-center fondo-tabla-head text-white">
                                <tr>
                                    <th>Editar</th>
                                    <th>Código</th>
                                    <th>Cantidad</th>
                                    <th>Descripción</th>
                                </tr>
                            </thead>
                            <tbody  v-for="(item, index) in listaArticulosExcelNoEncontrados" 
                                    :key="index" class="normal color-azul">
                                <tr>
                                    <td class="text-center" 
                                        style="width:30px!important">
                                        <button style="border:none" 
                                                class="text-white normal" 
                                                @click="editar(item, index)">
                                                <i class="fas fa-pencil-alt color-azul"></i>
                                        </button>
                                    </td>
                                    <td class="text-center editable" style="width:30px!important">
                                            <input  :ref="'item' + item.codArticulo + index"
                                                    :id="'item' + item.codArticulo + index"
                                                    :disabled="item.activo==false" 
                                                    oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                                                    @blur="validarArticuloEnCatalogo(item);item.activo=false" 
                                                    class="text-right w-input-codigo color-azul font-weight-bold"
                                                    v-model="item.codArticulo"
                                                    @keyup.enter.stop="item.activo=false"/>
                                    </td>
                                    <td class="text-center" 
                                        style="width:30px!important">
                                        {{item.cantidad}}
                                    </td>
                                    <td>
                                        <span>{{item.descripcion}}</span>
                                        <span v-if="item.estatus=='C'" class="text-danger font-weight-bold d-none d-lg-block"> Cancelado</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-12" v-if="listaArticulosExcelIncorrectos.length > 0">
                        <div class="text-center font-weight-bold">
                            <span class="text-danger">Favor de verificar que la cantidad solicitada sea correcta.</span>
                        </div>
                        <table  class="table table-sm table-bordered">
                            <thead class="text-center fondo-tabla-head text-white">
                                <tr>
                                    <th>Editar</th>
                                    <th>Código</th>
                                    <th>Cantidad</th>
                                    <th>Descripción</th>
                                </tr>
                            </thead>
                            <tbody  v-for="(item1, index) in listaArticulosExcelIncorrectos" 
                                    :key="index" class="normal color-azul">
                                <tr>
                                    <td class="text-center" 
                                        style="width:30px!important">
                                        <button style="border:none" 
                                                class="text-white" 
                                                @click="editar(item1, index)">
                                            <i class="fas fa-pencil-alt color-azul"></i>
                                        </button>
                                    </td>
                                    <td class="text-center" 
                                        style="width:30px!important">
                                        <span v-if="item1.codBarras != ''">
                                            {{item1.codBarras}}
                                        </span>
                                        <span v-else>
                                            {{item1.codArticulo}}
                                        </span>
                                    </td>
                                    <td class="text-center editable" 
                                        style="width:30px!important">
                                        <input  :ref="'item' + item1.codArticulo + index"
                                                :id="'item' + item1.codArticulo + index"
                                                class="text-right w-input-cantidad color-azul font-weight-bold" 
                                                :disabled="item1.activo==false" 
                                                @blur="validarArticuloEnCatalogoCantidad(item1);item1.activo=false" 
                                                v-model="item1.cantidad"
                                                oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');"
                                                @keyup.enter.stop="item1.activo=false" />
                                    </td>
                                    <td>
                                        {{item1.descripcion}}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>    
            </div>
            <div class="row fuente-textos d-block d-lg-none text-center">
                <div class=" offset-1 col-10 borde mt-2">
                    <span class="font-weight-bold">Opción 1:</span>
                        Puede modificar el 
                        código del producto
                        dando clic en el botón
                        "Editar"<i class="fas fa-pencil-alt color-azul"></i>        
                    <div class="mt-1">
                        <span class="font-weight-bold">Opción 2:</span>
                            Puede descargar su tabla en un archivo de excel, 
                            y hacer las modificaciones 
                            directamente desde su dispositivo. 
                            Dando clic en el botón : 
                            <span class="font-weight-bold">"Descargar tablas"</span>
                    </div>
                </div>
            </div>
            <div class="row m-2 d-block d-lg-none">
                <div class="col-12 align-items-center text-center">
                    <button class="btn btn-sm bg-descarga borde fuente-textos" @click="onexport">Descargar tablas</button>
                </div>
            </div>
            <div class="row fuente-textos mb-5">
                <div class="col-12 color-azul text-center" v-if="confirmacionContinuar">
                    Su pedido se surtirá sin los productos en las tablas.
                </div>
                <div class="col-12 text-center" v-if="!confirmacionContinuar">
                    <button class="btn btn-sm btn-amarillo font-weight-bold borde-regresar" @click="regresarAlCarrito">Regresar al carrito</button>
                    <button class="btn btn-sm btn-azul text-white" @click="continuar">Continuar</button>
                </div>
                <div class="col-12 text-center" v-if="confirmacionContinuar">
                    <div class="color-azul font-weight-bold">
                        ¿Está de acuerdo?
                    </div>
                    <button class="btn btn-sm btn-amarillo font-weight-bold borde-regresar" @click="confirmarNo">No</button>
                    <button class="btn btn-sm btn-azul text-white" @click="confirmarSi">Si</button>
                </div>
            </div>
            <b-modal ref="my-modal">
                <div class="align-items-center text-center">
                    <div class="row">
                        <div class="col-12">
                            <i class="bi bi-info-circle" style="font-size:90px"></i>
                            <i class="far fa-info-circle"></i>
                            <i class="fas fa-info-circle text-info" style="font-size:90px"></i>
                        </div>
                        <div class="col-12 text-center mt-2">
                            {{textoInfo}}
                        </div>
                        <div class="col-12 text-center mt-5 mb-1">
                            <button class="btn btn-info"  variant="outline-info" @click="cerrarModal" >Ok</button>
                        </div>
                    </div>
                </div>
            </b-modal>
        </b-modal>
    </div>
</template>
<script>
    import servicio from "@/services/servicio-carrito"
    import servicioExcel from "@/services/servicio-excel"
	//import XLSX from 'xlsx'
    import PmTablaCarrito from "@/components/clientes/TablaCarrito"
    //import FileSaver from 'file-saver'

    export default {
        props:["rutaCargado"],
        data() {
            return {
				listaArticulosExcel:[],
                listaArticulosExcelEnviar:[],
                listaArticulosExcelIncorrectos:[],
                listaArticulosExcelNoEncontrados:[],
                ruta:'',
                articuloEnCatalogo:{},
                confirmacionContinuar:false,
                textoInfo:''
            }
        },
        components:{
            PmTablaCarrito
        },
        mounted() {
            this.ruta = this.rutaCargado
        },
        methods: {
            regresarAlCarrito(){
                this.$bvModal.hide("modal-articulos-excel-incorrectos")
            },
            continuar(){
                if(this.listaArticulosExcelNoEncontrados.length > 0 || this.listaArticulosExcelIncorrectos.length > 0){
                    this.confirmacionContinuar=true
                }
                else{
                    this.confirmarSi()
                }
                
            },
            confirmarSi(){
                this.confirmacionContinuar=false
                this.$bvModal.hide("modal-articulos-excel-incorrectos")
                this.$bvModal.show("modal-articulos-excel")
            },
            confirmarNo(){
                this.confirmacionContinuar=false
            },
            validarArticuloEnCatalogoCantidad(item){
                // valida que tenga gantidad para poder agregarlo al carrito
                if( isNaN(item.cantidad) || parseInt(item.cantidad) <= 0 || item.cantidad.toString().trim() ==''){
                    this.textoInfo = 'La cantidad tiene que ser mayor a 0'
                    this.$refs['my-modal'].show()
                    // this.$bvToast.toast(`La cantidad tiene que ser mayor a 0`, {
                    //     title: "Carrito de compras",
                    //     autoHideDelay: 3000,
                    //     appendToast: false,
                    //     variant: "info",
                    // })
                    item.cantidad = 0
                    return
                }
                else{
                    this.validarArticuloEnCatalogo(item)
                }
            },
            validarArticuloEnCatalogo(item){
                this.$loading(true)
                if(item.codArticulo == ''){
                    item.codArticulo = 0
                }
                this.articuloEnCatalogo = {}
                servicioExcel.validarExistenciaArticulo(item.codArticulo)
                    .then((r) => {
                        if(r.value){
                            this.$loading(false)
                            this.articuloEnCatalogo = r.data[0]
                            // si no esta cancelado y tiene cantidad se agrega al carrito
                            if(this.articuloEnCatalogo.estatus !== 'C' && item.cantidad > 0){
                                this.articuloEnCatalogo.cantidad = item.cantidad
                                this.listaArticulosExcelIncorrectos = this.listaArticulosExcelIncorrectos.filter(x => x.codArticulo !== item.codArticulo)
                                this.listaArticulosExcelNoEncontrados = this.listaArticulosExcelNoEncontrados.filter(x => x.codArticulo !== item.codArticulo)
                                this.agregarArticuloLista()
                                this.$bvToast.toast(`Se agregó el artículo al carrito`, {
                                    title: "Carrito de compras",
                                    autoHideDelay: 3000,
                                    appendToast: false,
                                    variant: "success",
                                })
                            }
                            // si es un articulo valido pero no tiene cantidad se pasa a la tabla de las cantidades incorrectas 
                            else if(item.cantidad <= 0){
                                if(this.articuloEnCatalogo.estatus !== 'C'){
                                    let index = this.listaArticulosExcelNoEncontrados.findIndex(x => x.codArticulo == this.articuloEnCatalogo.codArticulo)
                                    
                                    if(index == -1){//si no lo encontro por codigo de articulo lo busca por codigo de barras
                                        //busca por codigo de barras
                                        index = this.listaArticulosExcelNoEncontrados.findIndex(x => x.codArticulo == this.articuloEnCatalogo.codBarras)

                                        this.listaArticulosExcelNoEncontrados.splice(index,1)
                                        this.listaArticulosExcelIncorrectos = this.listaArticulosExcelIncorrectos.filter(x => x.codBarras !== this.articuloEnCatalogo.codBarras)
                                        this.listaArticulosExcelIncorrectos.push({codArticulo:this.articuloEnCatalogo.codArticulo, cantidad:item.cantidad, descripcion:this.articuloEnCatalogo.descripcion, activo:false, codBarras: this.articuloEnCatalogo.codBarras})
                                        //this.listaArticulosExcelIncorrectos.push({'codArticulo':this.articuloEnCatalogo.codArticulo, 'cantidad':item.cantidad,'descripcion':this.articuloEnCatalogo.descripcion,'activo':false, 'estatus':this.articuloEnCatalogo.estatus})
                                    }
                                    if(index >= 0){
                                        this.listaArticulosExcelNoEncontrados.splice(index,1) //this.listaArticulosExcelNoEncontrados.filter(x => x.codArticulo !== this.articuloEnCatalogo.codArticulo)
                                        this.listaArticulosExcelIncorrectos = this.listaArticulosExcelIncorrectos.filter(x => x.codArticulo !== this.articuloEnCatalogo.codArticulo)
                                        this.listaArticulosExcelIncorrectos.push({'codArticulo':this.articuloEnCatalogo.codArticulo, 'cantidad':item.cantidad,'descripcion':this.articuloEnCatalogo.descripcion,'activo':false, 'estatus':this.articuloEnCatalogo.estatus, codBarras: ''})
                                    }
                                }
                            }
                            // si el articulo tiene cantidad y esta cancelado no hace nada solo envia el mensaje de cancelado
                            else{
                                this.textoInfo = r.message
                                this.$refs['my-modal'].show()
                                // if(this.articuloEnCatalogo.estatus !== 'C'){
                                //     this.textoInfo = r.message
                                //     this.$refs['my-modal'].show()
                                    
                                //     let index = this.listaArticulosExcelNoEncontrados.findIndex(x => x.codArticulo == this.articuloEnCatalogo.codArticulo)
                                //     if(index < 0){
                                //         this.listaArticulosExcelIncorrectos = this.listaArticulosExcelIncorrectos.filter(x => x.codArticulo !== this.articuloEnCatalogo.codArticulo)
                                //         this.listaArticulosExcelNoEncontrados.push({'codArticulo':this.articuloEnCatalogo.codArticulo, 'cantidad':this.articuloEnCatalogo.cantidad,'descripcion':this.articuloEnCatalogo.descripcion,'activo':false, 'estatus':this.articuloEnCatalogo.estatus})
                                //     }
                                // }
                            }
                        }
                        else{
                            this.$loading(false)
                            this.textoInfo = r.message
                            this.$refs['my-modal'].show()

                            //busca si existe en los articulos que no encontró en la base de datos, en caso de no existir inserta el dato que tenía la cantidad incorrecta
                            let index = this.listaArticulosExcelNoEncontrados.findIndex(x => x.codArticulo == item.codArticulo)
                            if(index < 0){
                                this.listaArticulosExcelIncorrectos = this.listaArticulosExcelIncorrectos.filter(x => x.codArticulo !== item.codArticulo)
                                this.listaArticulosExcelNoEncontrados.push(item)
                            }
                        }
                    })
                    .catch((err)=>{
                        this.$loading(false)
                        console.log('validarArticuloEnCatalogo', err)
                    })
            },
            cerrarModal(){
                this.$refs['my-modal'].hide()
            },
            agregarArticuloLista(){
                let index = this.listaArticulosExcelEnviar.findIndex(x => x.codArticulo == this.articuloEnCatalogo.codArticulo)
                if(index >= 0){
                    this.listaArticulosExcelEnviar[index].cantidad = parseInt(this.listaArticulosExcelEnviar[index].cantidad) + this.articuloEnCatalogo.cantidad
                }
                else{
                    this.listaArticulosExcelEnviar.push(this.articuloEnCatalogo)
                }

                if(this.listaArticulosExcelNoEncontrados.length == 0 && this.listaArticulosExcelIncorrectos.length == 0){
                    this.continuar()
                }

            },
            onexport () {
                let articulos = []
                this.listaArticulosExcelNoEncontrados.forEach(element => {
                    articulos.push({'codArticulo':element.codArticulo, 'cantidad':element.cantidad,'descripcion':element.descripcion, 'info':'no existe en catalogo'})
                });
                this.listaArticulosExcelIncorrectos.forEach(element => {
                    articulos.push({'codArticulo':element.codArticulo, 'cantidad':element.cantidad,'descripcion':element.descripcion, 'info':'cantidad incorrecta'})
                });

                let articulosXml = XLSX.utils.json_to_sheet(articulos, {skipHeader:true}) 
                let wb = XLSX.utils.book_new()

                XLSX.utils.book_append_sheet(wb, articulosXml, 'articulos')
                XLSX.writeFile(wb, 'ArticulosNoProcesados.xlsx')
            },
            editar(item, index){
                let input = this.$refs['item' + item.codArticulo + index]
                item.activo = true
                
                this.$nextTick(()=>{
                    input[0].disabled = false
                    input[0].focus()
                    input[0].select()
                })
            },
            async readExcel(e) { 
                this.$loading(true)
                this.surtidoDesdeExcel = false
                this.listaArticulosExcel = []
                this.listaArticulosExcelEnviar = []
                this.listaArticulosExcelIncorrectos = []
                this.listaArticulosExcelNoEncontrados = []
                

                const files = e.target.files;
                const fileReader = new FileReader()
                fileReader.onload = ev => {
                    const data = ev.target.result;
                    const workbook = XLSX.read(data, {
                        type: "binary"
                    })
                    const wsname = workbook.SheetNames[0]
                    const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname], { header: 1 })
                    ws.forEach((value) => {
                        if(value[0]){
                            if(parseInt(value[1]) > 0){
                                this.listaArticulosExcel.push({codArticulo:value[0].toString(), cantidad:value[1], descripcion:value[2]})
                            }
                            else{
                                this.listaArticulosExcel.push({codArticulo:value[0].toString(), cantidad:0, descripcion:value[2]})
                                //this.listaArticulosExcelIncorrectos.push({codArticulo:value[0].toString(), cantidad:0, descripcion:value[2], activo:false})
                            }
                        }
                    })
                    
                    servicio.consultarArticulosEXCEL(this.listaArticulosExcel)
                    .then((r) => {
                        this.$loading(false)
                        this.listaArticulosExcelEnviar = r.data['articulosEnCatalogo'].filter((x) => x.cantidad > 0)
                        
                        let arr = r.data['articulosEnCatalogo'].filter((x) => x.cantidad == 0)
                        arr.forEach(element => {
                            this.listaArticulosExcelIncorrectos.push({codArticulo:element.codArticulo, cantidad:0, descripcion:element.descripcion, activo:false, codBarras: element.codBarras})
                        });
                        this.listaArticulosExcelNoEncontrados = r.data['articulosNoEncontrados']

                        if(this.listaArticulosExcelNoEncontrados.length > 0 || this.listaArticulosExcelIncorrectos.length > 0){
                            this.$bvModal.show("modal-articulos-excel-incorrectos")
                        }
                        else if(r.data['articulosEnCatalogo'].length > 0){
                            this.$bvModal.show("modal-articulos-excel")
                        }
                        else{
                            this.textoInfo = 'No se encontraron artículos con los datos del archivo proporcionado.'
                            this.$refs['my-modal'].show()
                            //this.$msg.info( 'No se encontraron artículos con los datos del archivo proporcionado.' )
                        }
                    })
                    .catch((e) => {
                        this.$loading(false)
                        console.log('catch', e)
                    })
                };

                fileReader.readAsBinaryString(files[0])
                this.$refs['input-file'].value = null;
            },
			togleMenu(opcion) {
                this.$emit('togleMenu', opcion)
			},
        },
    }
</script>
<style scoped>
.editable{
    background-color:#d3d6dc;
}
.normal{
    background-color:#ebebeb;
}
@media (max-width: 991px) {
    .rows {
        border-left:none !important;
    }
    .fuente-textos{
        font-size: 12px !important;
    }
    .w-input-codigo{
        width: 100px !important;
    }
    .w-input-cantidad{
        width: 50px !important;
    }
}
@media (min-width: 992px) {
    .rows {
        border-left: solid 4px#7c859e;
    }
    .fuente-textos{
        font-size: 17px !important;
    }
    .w-input-cantidad{
        width: 70px !important;
    }
}
.w-input-codigo{
    width: 150px;
}
.w-input-cantidad{
    width: 100px;
}

.fuente-textos{
    font-size: 12px;
}
.btntooltiptext::before {
    content: "";
    position: absolute;
    top: -5px;
    left: 0px;
    border-top: -5px solid transparent !important;
    border-right: 10px solid transparent;
    border-bottom: 10px solid white;
    border-left: 10px solid transparent;
}

.btntooltip {
    position: relative;
    display: inline-block !important;
}

.btntooltip .btntooltiptext {
    width: 150px;
    visibility: hidden;
    background-color: #fff;
    color: #101a33;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
}

.btntooltip:hover .btntooltiptext {
    visibility: visible;
}
.fondo-tabla-head {
    background-color: #273c6f !important;
}
.color-azul{
    color:#273c6f !important;
}
.rows {
    border-left: solid 4px#7c859e;
}
.borde {
    border: solid 4px#7c859e;
    border-radius: 5px;
}
.borde-regresar{
    border: solid 1px#273c6f;
    color: #273c6f;
    border-radius: 5px;
}
.bg-descarga{
    background-color: #7c859e;
}
.triangulo{
    color: #f3d06d;
    font-size: 100px;
}
.btn-amarillo{
    background-color: #f3d06d;
    width: 200px;
    margin: 10px;
}

.btn-azul{
    background-color: #273c6f !important;
    color: white;
    width: 200px;
    margin: 10px;
}

    /* cambio que pidio samantha de mercadotecnia. */
    @media screen and (min-width: 1024px) {

        .botonWidth {
        width: 191px;
        }
    }
    
</style>